var _path, _mask, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3383 11.2782L19.4222 3.79321H1.57784L9.66168 11.2782C10.1407 11.7573 10.8593 11.7573 11.3383 11.2782ZM13.7934 10.9788L12.2964 12.3561C11.8174 12.8351 11.1587 13.0747 10.5 13.0747C9.84132 13.0747 9.18263 12.8351 8.64371 12.3561L7.20659 10.9788L1.51796 16.6675H19.482L13.7934 10.9788ZM14.8713 10.0208L20.5 15.6495V4.7513L14.8713 10.0208ZM6.12874 10.0208L0.5 4.7513V15.6495L6.12874 10.0208Z",
    fill: "rgba(0, 0, 0, 0.6)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.79321,
    width: 20,
    height: 13.3333,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.79321,
    width: 20,
    height: 13.3333,
    rx: 1,
    stroke: "rgba(0, 0, 0, 0.6)",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.d5cf02b5e64b2d6a2baedcafd649ca58.svg";
export { ForwardRef as ReactComponent };